/** @format */

export const NEW_ORGANIZATION_REQUEST = "NEW_ORGANIZATION_REQUEST";
export const NEW_ORGANIZATION_SUCCESS = "NEW_ORGANIZATION_SUCCESS";
export const NEW_ORGANIZATION_FAILURE = "NEW_ORGANIZATION_FAILURE";
